const SHOW = 'impulse/confirm/SHOW'
const HIDE = 'impulse/confirm/HIDE'
const UPDATE = 'impulse/confirm/UPDATE'

const noop = () => {}

const initialState = {
	show: false,
	title: null,
	text: null,
	variant: null,
	description: null,
	descriptionLink: null,
	expectedCode: null,
	codeLength: null,
	resetCodeKey: null,
	confirmText: null,
	cancelText: null,
	loading: false,
	blocking: false,
	hideCancel: false,
	onConfirm: noop,
	onCancel: noop,
}

const confirmReducer = (state = initialState, action) => {
	switch (action.type) {
		case SHOW:
			return {
				show: true,
				title: action.title,
				text: action.text,
				variant: action.variant,
				description: action.description,
				descriptionLink: action.descriptionLink,
				expectedCode: action.expectedCode,
				codeLength: action.codeLength,
				resetCodeKey: action.resetCodeKey,
				confirmText: action.confirmText,
				cancelText: action.cancelText,
				loading: action.loading,
				blocking: action.blocking,
				hideCancel: action.hideCancel,
				onConfirm: action.onConfirm,
				onCancel: action.onCancel,
			}
		case HIDE:
			return initialState
		case UPDATE:
			return {
				...state,
				...action.params,
			}
		default:
			return state
	}
}

export const show = (params) => ({ type: SHOW, ...params })
export const update = (params) => ({ type: UPDATE, params })
export const hide = () => ({ type: HIDE })

export default confirmReducer
